import { forwardRef } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'
import { ErrorMessage } from './FormField'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'required'> {
  label: ReactNode
  error?: string
  required?: boolean
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, className = '', required, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            ref={ref}
            type="checkbox"
            className={`
              w-4 h-4 rounded border-2
              cursor-pointer transition-all flex-shrink-0
              outline-none
              ${error
                ? 'border-red-600 text-red-600 focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-1'
                : 'border-neutral-400 text-primary focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 hover:border-neutral-600'}
              ${className}
            `}
            aria-required={required}
            {...props}
          />
          <span className="text-sm text-neutral-900 font-normal leading-normal select-none">
            {label}
            {required && <span className="text-red-600 ml-1">*</span>}
          </span>
        </label>

        {error && <ErrorMessage error={error} className="ml-6" />}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'

export default Checkbox
